<template>
  <view-hero title="dingen" paragraph="dingen"></view-hero>
  <div class="container">
    dingen
  </div>
</template>

<script>
import ViewHero from "@/lib/components/hero/ViewHero.vue";

export default {
  name: "DienstenDetail",
  components: {ViewHero}
}
</script>

<style scoped>

</style>